export const PUSH_TO_SIDEBAR_STACK = "sidebars/PUSH_TO_SIDEBAR_STACK"
export const TOGGLE_CURRENT_SIDEBAR = "sidebars/TOGGLE_CURRENT_SIDEBAR"
export const UPDATE_CURRENT_SIDEBAR = "sidebars/UPDATE_CURRENT_SIDEBAR"
export const GO_TO_THE_PREVIOUS_SIDEBAR = "sidebars/GO_TO_THE_PREVIOUS_SIDEBAR"
export const DELETE_THE_LAST_ELEMENT_SIDEBAR = "sidebars/DELETE_THE_LAST_ELEMENT_SIDEBAR"
